import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_URL + 'missionprecheckitem/';

class MissionPrecheckItemService {
  list(baliseId) {
    return axios.get(API_URL + baliseId, { headers: authHeader() });
  }

  create(baliseId, label) {
    return axios.post(API_URL + baliseId, { label }, { headers: authHeader() });
  }

  update(itemId, label) {
    return axios.put(API_URL + 'item/' + itemId, { label }, { headers: authHeader() });
  }

  remove(itemId) {
    return axios.delete(API_URL + 'item/' + itemId, { headers: authHeader() });
  }
}

export default new MissionPrecheckItemService();
